var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBedroom = function SvgBedroom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 2.3a.7.7 0 0 1 .7.7v3.3H5a4.701 4.701 0 0 1 4.648 4H19a2.7 2.7 0 0 1 2.7 2.7v8a.7.7 0 1 1-1.4 0v-3.157H3.7V21a.7.7 0 1 1-1.4 0V3a.7.7 0 0 1 .7-.7Zm.7 14.143h16.6V13a1.3 1.3 0 0 0-1.3-1.3H3.7v4.743ZM8.226 10.3H3.7V7.7H5a3.301 3.301 0 0 1 3.226 2.6Z",
    fill: "currentColor"
  })));
};
export default SvgBedroom;